import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useCallback } from 'react';
import { useCurrentUser } from '@/contexts';
import { analyticsClient } from '@/lib';
import { userService } from '@/services';
import { useFilterStore } from '@/stores/filterStore';

/**
 * "Free today" (`availableToday`) toggle shared by the discovery header pill
 * and the notes page "Pulp me" CTA. Turning off also clears the discovery
 * filter that only makes sense while live.
 */
export function useAvailableToday() {
  const { t } = useTranslation('discover');
  const { currentUser } = useCurrentUser();
  const isLive = currentUser?.availableToday ?? false;

  const setLive = useCallback(
    (next: boolean) => {
      const uid = currentUser?.uid;
      if (!uid) return;

      if (!next) {
        useFilterStore.getState().setAvailableToday(false);
      }

      userService
        .updateProfile(uid, { availableToday: next })
        .then(() => {
          analyticsClient.capture('available_today_toggled', {
            enabled: next,
            session_id: analyticsClient.getCurrentSessionId(),
          });
        })
        .catch(() => {
          toast.error(t('header.liveTodayError'));
        });
    },
    [currentUser, t]
  );

  return { isLive, setLive };
}
